<template>
  <div>
    <headerpage :status="0"></headerpage>
    <div class="deground">
      <div class="adaptation" style="background-color: #f6f8f7;">
        <div class="hetext">首页>{{type==1?'园区通知':'园区要闻'}}</div>
        <div class="box">
          <el-tabs class="box_cet tab-pane1" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane :label="item.name" :name="String(index)" v-for="(item,index) in tablist" class="xia" ></el-tab-pane>
          </el-tabs>
        </div>
        <div class="box1">
          <!-- <div class="box1_top">
          <div class="box1_top_left">筛选:</div>
          <div class="box1_top_right">
            <div class="box1_top_tt" v-for="(item,index) in 5" :style="index==0?'color: #0170c1;':''">筛选项AXXXX</div>
          </div>
        </div> -->
          <div class="box1_cent tablecss">
            <el-table :data="tableData" style="width: 100%">
              <el-table-column prop="title" label="标题" width="700px">
              </el-table-column>
               
              <el-table-column prop="cat_name" label="类型">
              </el-table-column>
              <el-table-column prop="realse_time" label="发布时间">
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <template v-if="type==1">
                    <div @click="detailchange('detail',scope.row.id,3)" class="detaii">查看详情</div>
                  </template>
                  <template v-else>
                    <div @click="detailchange('detail',scope.row.id,4)" class="detaii">查看详情</div>
                  </template>
                   
                </template>
              </el-table-column>
            </el-table>
            <!-- <nomore></nomore> -->
          </div>
          <div class="box1_fot pagecss">
            <el-pagination background :page-size="pagesize" :hide-on-single-page="true"
                                layout="prev, pager, next" 
                                @current-change="handleCurrentChange" :current-page="currentPage" :total="totalnum">
               </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import headerpage from '../../components/header/header.vue';
export default {
  data() {
    return {
      activeName: '0',
      currentPage:1,
      pagesize:20,
      totalnum:0,
      tableData: [],
      type:1,
      tablist:[
        {
          id:0,
          name:'全部'
        }
      ]
    }
  },
  methods: {
    handleCurrentChange: function (currentPage) {
            this.currentPage = currentPage;
            // console.log(this.currentPage)  //点击第几页
            // this.rightlist = [];
            this.notice_list();
        },
    handleClick(){
      this.notice_list()
    },
    notice_list() {
      var api = this.$api.api.demo.notice_list;
      this.$https.post({
        api: api,
        type: "formData",
      }, {
        page: this.currentPage,
        page_size:this.pagesize,
        type: this.type,
        cat_id:this.tablist[this.activeName].id
      }, (response) => {
        this.totalnum = response.count
        this.tableData = response.data
      }, (error) => {
        console.log(error);
      });
    },
    notice_cat(){
      var api = this.$api.api.demo.notice_cat;
      this.$https.post({
        api: api,
        type: "formData",
      }, {
        type: this.type
      }, (response) => {
        this.tablist = this.tablist.concat(response.data)
      }, (error) => {
        console.log(error);
      });
    },
    detailchange(name, id, type) {
      console.log(id,'idididididididid')
      this.$router.push({ name: name, query: { type: type, id: id } });
    },
  },
  created: function () {

    var type = this.$route.query.type;
    this.type = type
    this.notice_list()
    this.notice_cat()
  },
  components: { headerpage }
}
</script>
<style lang="scss">
.tab-pane1 {
  .el-tabs__header {
    margin: 0;
  }

  .el-tabs__item {
    // padding-left: 20px !important;
    font-weight: 600;
  }

  .el-tabs__nav-wrap::after {
    height: 0;
  }

  .el-tabs__active-bar {
    width: 0 !important;
  }

  .is-active {
    position: relative;
    transition: 0.5s;
    color: #0170c1 !important;

  }

  .is-active::after {
    content: '';
    position: absolute;
    width: 18px;
    height: 3px;
    background-color: #0170c1;
    border-radius: 2px;
    left: 50%;
    transform: translate(-50%, -50%);
    bottom: 0;
  }

  .el-tabs__item:hover {
    color: #0170c1;
  }

  .el-tabs__item:nth-child(2)::after {
    margin-left: -10px;
  }
  .el-tabs__item:last-child::after{
    margin-left: 10px;
  }
  .el-tabs__nav-next,
  .el-tabs__nav-prev {
    font-size: 20px;
    line-height: 40px;
  }

  .el-tabs__nav-wrap.is-scrollable {
    padding: 0 25px;
  }
}
</style>
<style scoped>
.hetext {
  font-size: 15px;
  color: #bdbdbd;
  padding: 16px 0;
  cursor: pointer;
}

.box {
  height: 77px;
  background-color: #ffffff;
  border-radius: 10px 10px 0px 0px;
  width: 100%;
  display: flex;
  align-items: center;
  /* line-height: 77px; */
  padding: 0 10px;
}

.box_cet {
  width: 100%;
}

.box1 {
  padding: 30px;
  background-color: #ffffff;
  border-radius: 0px 0px 10px 10px;
  margin-top: 7px;
}

.box1_top {
  display: flex;
}

.box1_top_left {
  font-size: 16px;
  color: #2f2f2f;
  font-weight: 600;
  width: 75px;
}

.box1_top_right {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  flex: 1;
}

.box1_top_tt {
  margin-right: 36px;
  font-size: 16px;
  color: #7f7f7f;
  cursor: pointer;
}

.box1_top_tt:last-child {
  margin-right: 0;

}

.box1_fot {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.box1_cent {
  margin: 25px 0;
  margin-top: 0;
}

.detaii {
  padding: 8px;
  color: #fff;
  background-color: #0170c1;
  border-radius: 10px;
  text-align: center;
  margin: 0 auto;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// listpage.vue?aebf4fd6